export default __webpack_public_path__ + "static/img-triple-crown-point-second-43b1795f6c0e053e521f77be87b5d9b7.avif";